<template>
    <div class="fill-absolute" :class="{ 'grey darken-4': skinData==='dark', 'white': skinData==='light', 'gray lighten-5': skinData === 'gray' }">
        <div class="load-container">
            <div class="loader" :class="{ 'dark': skinData==='light' || skinData==='gray' }"></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Loader',
        data: () => ({

        }),
        computed: {
            skinData: function() {
                var $allowed = [ "dark", "light", "gray" ];
                return typeof this.$props.skin === "undefined" || this.$props.skin === null || $allowed.indexOf(this.$props.skin) === -1 ? "dark" : this.$props.skin;
            }
        },
        props: {
          skin: String,
          color: String
        }
    }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue